module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_8004.a1075c23.png";